import { Row } from "antd";
import { useHasContractMessagesAccess } from "../../../../../../../lib/hooks/useHasMessagesAccess";
import { ChatOption } from "./ChatOption";
import { Option } from "./Option";
import {
  FileTextOutlined,
  FormOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { useGetContractRole } from "../../../../../../../lib/hooks/getContractRole";

type AdditionalLinksProps = {
  accountGeneralData: any;
};

export const AdditionalLinks = ({
  accountGeneralData,
}: AdditionalLinksProps) => {
  const { canViewMessages } = useHasContractMessagesAccess(
    accountGeneralData.allowChatConversation,
  );

  const { getContractRole } = useGetContractRole();
  const { isPrimary, isBuyer } = getContractRole(accountGeneralData);

  return (
    <Row className="d-block w-100 additional-links">
      <Option
        path={`/accounts/${accountGeneralData.accountNumber}/payment-history`}
        title="Payment History"
        icon={<HistoryOutlined className="text" />}
        mobileOnly
      />
      <Option
        path={`/accounts/${accountGeneralData.accountNumber}/documents`}
        title="Documents"
        icon={<FileTextOutlined className="text" />}
      />
      {isPrimary && (
        <Option
          path={`/accounts/${accountGeneralData.accountNumber}/fillable-forms`}
          title="Requests & Forms"
          icon={<FormOutlined className="text" />}
          mobileHidden={!isBuyer}
        />
      )}
      {canViewMessages && (
        <ChatOption
          accountNumber={accountGeneralData.accountNumber}
          isBuyer={isBuyer}
        />
      )}
    </Row>
  );
};
